export default {
  how_much_you_know: {
    consumption:
      'Hvor mye kan du om hvordan varer og tjenester henger sammen med klima?',
    energy: 'Hvor mye kan du om energi og klima?',
    transport: 'Hvor mye kan du om transport og klima?',
    food: 'Hvor mye kan du om mat og klima?',
    microplastics: 'Hvor mye kan du om plast og klima?',
  },
  back: {
    consumption: 'Varer & Tjenester info',
    energy: 'Energi info',
    transport: 'Transport info',
    food: 'Mat info',
    microplastics: 'Mikroplast info',
  },
  go_to: {
    consumption: 'Gå til varer & tjenester info',
    energy: 'Gå til energi info',
    transport: 'Gå til transport info',
    food: 'Gå til mat info',
    microplastics: 'Gå til mikroplast info',
  },
  test_knowledge: {
    consumption: 'Varer & Tjenester - Test din kunnskap',
    energy: 'Energi - Test din kunnskap',
    transport: 'Transport - Test din kunnskap',
    food: 'Mat - Test din kunnskap',
    microplastics: 'Mikroplast - Test din kunnskap',
  },
  end_page: {
    tough: 'Det var utfordrende!',
    congrats: 'Gratulerer!',
    use_knowledge: {
      consumption:
        'Bruk denne varer & tjenester-kunnskapen for å fortsette å redde verden.',
      energy: 'Bruk denne energi-kunnskapen for å fortsette å redde verden.',
      transport:
        'Bruk denne transport-kunnskapen for å fortsette å redde verden.',
      food: 'Bruk denne mat-kunnskapen for å fortsette å redde verden.',
      microplastics:
        'Bruk denne mikroplastikk-kunnskapen for å fortsette å redde verden.',
    },
    compare_with_others: 'Sammenlign med andre i %{organisationName}',
  },
  common: {
    continue: 'Fortsett',
    num_questions: '%{currentQuestion}/%{totalQuestions} spørsmål',
    review_answers: 'Gjennomgå svarene',
    answer_questions:
      'svar på %{smart_count} spørsmål |||| svar på %{smart_count} spørsmål',
    true: 'SANT',
    false: 'USANT',
  },
  buying_something: {
    question: 'Å kjøpe noe kan være bedre for miljøet enn å kjøpe ingenting',
    explanation: `MARKDOWN:
Å leve bærekraftig innebærer ikke bare å gjøre eller kjøpe mindre. Det handler også om hvordan du bruker de pengene du har. Penger spares sjeldent i evig tid, så selv om du ikke kjøper noe i dag, betyr det ikke at du ikke kommer til å bruke de pengene i morgen - på noe som er verre for miljøet. 

Derfor er aktiviteter som å gi bort penger, eller å kjøpe det du trenger brukt, gode alternativer - de er eksempler på bærekraftige handlemønster.
`,
  },
  buying_clothing: {
    question:
      'Å kjøpe klær for 200 euro hos en internasjonal motgigant vil forårsake ca hvor mange kilo med CO₂e utslipp?',
    options: {
      25: '25 kgCO\u2082e',
      50: '50 kgCO\u2082e',
      100: '100 kgCO\u2082e',
    },
    explanation: `MARKDOWN:
Det ville føre til utslipp i størrelsesorden 100 kgCO\u2082e som er tilsvarende å kjøre 500 km i bil. Disse store utslippene kommer av at man må dyrke bomull, drive fabrikker, transportere klær, lagre dem og selge dem.

Klesproduksjon krever i tillegg enorme mengder ferskvann og bruk av store landarealer som legger press på våre uerstatelige økosystemer.
`,
  },
  e_waste: {
    question: 'El-avfall avhendes på en ansvarlig måte, på verdensbasis',
    explanation: `MARKDOWN:
Verden genererte 53,6 millioner tonn elektronisk og elektrisk utstyrsavfall (e-avfall) i 2019, en økning på mer enn 20 prosent sammenlignet med 2014.

Deponering av e-avfall kan frigjør giftige kjemikalier i jord og vann, og utgjør en helse- og miljørisiko.
`,
  },
  energy_greenhouse: {
    question:
      'Hvert år vil klimagassutslippene knyttet til produksjon av elektrisitet i Europa...',
    options: {
      decrease: 'krympe',
      increase: 'øke',
    },
    explanation: `MARKDOWN:
Hvert år reduseres klimagassutslippene knyttet til produksjon av elektrisitet i Europa – redusert med nesten 50 % siden 2000!

Imidlertid er vi i økende grad avhengig av elektrisitet, for eksempel for å drive elbiler. Det betyr at hvis vi ikke forbedrer effektiviteten og reduserer energiforbruket, vil etterspørselen etter elektrisitet fortsette å vokse.

Jo mer elektrisitet vi trenger, desto mer landareal og ressurser trenger vi for å bygge fremtidens vindmøller og solfarmer.
`,
  },
  heating_cooling: {
    question:
      'Mesteparten av energien som brukes i husholdninger går til oppvarming og/eller kjøling.',
    explanation: `MARKDOWN:
Mesteparten av energien som brukes i husholdninger går til oppvarming og/eller kjøling.
 
Juster termostaten i huset ditt for å redusere oppvarmings- eller kjølebehov og spare energi, eller invester i energieffektive teknologier som isolasjon og varmepumper for å redusere det totale energiforbruket ditt.
`,
  },
  fossil_fuel_percentage: {
    question:
      'Omtrent hvor mange prosent av verdens energi kommer fortsatt fra fossilt brensel?',
    options: {
      30: '30%',
      50: '50%',
      80: '80%',
    },
    explanation: `MARKDOWN:
Selv om fornybare energikilder bygges ut i rekordfart, står fortsatt fossilt brensel for det meste av verdens energiproduksjon - rundt 84 % i 2019.
`,
  },
  convenient_public: {
    question:
      'Omtrent hvor mange prosent av verdens urbane befolkning har praktisk tilgang til offentlig transport?',
    options: {
      30: '30%',
      50: '50%',
      70: '70%',
    },
    explanation: `MARKDOWN:
Bare halvparten av verdens urbane befolkning har praktisk tilgang til offentlig transport. (49,5 % for å være nøyaktig)

Praktisk tilgang betyr å bo innen 500m gangavstand fra et busstopp/lavkapasitets transportsystem eller1000m fra en jernbane eller fergeterminal.
`,
  },
  long_distance_train: {
    question:
      'Den mest miljøvennlige måten å foreta langdistansereiser, er å ta toget.',
    explanation: `MARKDOWN:
Over lengre avstander er togreise stort sett det beste alternativet. Et tog avgir betydelig mindre direkteutslipp enn et fly, spesielt hvis det er elektrisk. (Utslippene fra dieseltog er dobbelt så høye som fra elektriske tog)
`,
  },
  bike_infrastructure: {
    question:
      'Hvis det ikke finnes trygge gang og sykkelfelt i ditt område er det ingenting du kan gjøre med det',
    explanation: `MARKDOWN:
Folk er definitivt mer tilbøyelige til å gå og sykle hvis gatene føles trygge og trivelige - for eksempel lavhastighetssoner for biler, bredere fortau eller sykkelfelt. Men bare fordi dette ikke eksisterer, betyr det ikke at det ikke er noe du kan gjøre med det.

Start en kampanje for å vise politikere at det er betydelig etterspørsel etter et mer bærekraftige transportalternativ og at du er villig til å være med på å utforske hvordan dette systemet vil se ut i fremtiden.
`,
  },
  food_waste_percentage: {
    question:
      'Hvor mange prosent av maten som er tilgjengelig for forbrukerne kastes?',
    options: {
      4: '4%',
      17: '17%',
      36: '36%',
    },
    explanation: `MARKDOWN: 
I følge forskning fra FN, havner 17 % av maten som var tilgjengelig for forbrukerne i 2019, i søppelbøttene til husholdninger, forhandlere, restauranter og andre mattjenester.

Det er 931 millioner tonn mat, som omtrent tilsvarer 23 millioner fullastede 40-tonns lastebiler – støtfanger-til-støtfanger, nok til å sirkle jorden 7 ganger.
`,
  },
  half_agriculture: {
    question: 'Halvparten av verdens beboelige landområder brukes til jordbruk',
    explanation: `MARKDOWN:
Halvparten av verdens beboelige land brukes til jordbruk. Utvidelsen av jordbruksområder er en trussel for biologisk mangold, og dermed miljøet vårt. 

24 000 av de 28 000 artene som er evaluert til å være truet av utryddelse på IUCNs rødliste har landbruk oppført som en trussel.
`,
  },
  sea_food_transport: {
    question: 'Mesteparten av maten vår fraktes med båt, ikke med fly',
    explanation: `MARKDOWN:
Det er ofte antatt at å kjøpe lokalprodusert mat er en effektiv måte å redusere fotavtrykket. Men hvordan maten din produseres har mye større påvirkning på fotavtrykket enn hvor det produseres. Kun noe få matvarer fraktes med fly, og utslippene forbundet med båttransport er svært lave.
`,
  },
  plastic_recycling_percentage: {
    question:
      'Hvor mange prosent av alt produsert plastavfall har blitt resirkulert?',
    options: {
      9: '9%',
      29: '29%',
      49: '49%',
    },
    explanation: `MARKDOWN:
Foreløpig er bare 9 % av alt produsert plastavfall er blitt resirkulert. Omtrent 12 % av avfallet er brent, mens de resterende 79 % har blitt dumpet på søppelfyllinger eller naturmiljø.
`,
  },
  million_plastic_bottles: {
    question: 'En million plastflasker kjøpes globalt ...',
    options: {
      minute: 'hvert minutt',
      hour: 'hver time',
      day: 'hver dag',
    },
    explanation: `MARKDOWN:
1 million plastflasker kjøpes globalt hvert minutt.

De fleste brusflasker i plast er laget av polyetylentereftalat (PET), som kan resirkuleres i stor grad. Dessverre kommer forsøk på å samle og resirkulere disse, og dermed hindre at plast havner på avveie, til kort.
`,
  },
  plastic_lasts: {
    question: 'Hvor lenge antas plast å vare i naturen?',
    options: {
      '1to2years': '1 til 2 år',
      '50to100years': '50 til 100 år',
      forever: 'Muligens for alltid',
    },
    explanation: `MARKDOWN:
Det er mye forskning som viser at plast blir i naturen veldig lenge – muligens for alltid.

Den brytes opp til mindre og mindre biter fra såkalt “makroplast” til “mikroplast” og til slutt til “nanoplast”. 

Mikroplast er plastbiter på mellom 1 mikrometer til 5 millimeter - nanoplast er enda mindre.
`,
  },
};
